<template>
  <v-card tile flat class="mainContent theme-back" :class="isMirrored ? 'mainContentReversed' : ''" :dark="dark"
          v-hotkey="keymap">
    <v-card tile flat class="sideCard theme-back" :style="{width: buttonsWidth, minWidth: buttonsWidth}">
      <v-card tile flat class="personList theme-back">
        <PlayerList :gamefinished="gameFinished" :persons="{...gamedata.team_a_players}" id="teamA" team="A"
                    :isActive="teamA.isActive"
                    :show="true" :itemCount="maxTeamSize" :gamedata="gamedata" :hotkeys="hotkeys"
                    :side="isMirrored ? 'right' : 'left'"
                    v-if="Object.keys(gamedata).length > 0 && Object.keys(gamedata.team_a_players).length > 0"
                    :actualGoalKeeper="{...gamedata.team_a_actual_goalkeeper}"
                    :playerEntry="gamedata.team_a_players_entry"/>
        <PlayerList :gamefinished="gameFinished" :persons="{...gamedata.team_a_officials}" id="staffA" team="A"
                    :isActive="teamA.isActive"
                    v-if="Object.keys(gamedata).length > 0 && Object.keys(gamedata.team_a_officials).length > 0"
                    :actualGoalKeeper="{}" :gamedata="gamedata" :hotkeys="hotkeys" :show="showA"
                    :itemCount="gamedata.team_a_officials.length" :isOver="true"/>
      </v-card>

      <a @click="showA = !showA" class="toggle-btn">
        <v-icon class="t-icon theme-text">{{ !showA ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        <span class="t-text theme-text">{{ !showA ? 'Hivatalos személyek' : 'Bezárás' }}</span>
      </a>
    </v-card>

    <v-card tile flat class="midContent theme-back">
      <v-card tile flat class="d-flex justify-space-between align-center topButtonset theme-back"
              :class="isMirrored ? 'flex-row-reverse': ''" width="100%" height="67px">
        <v-card tile flat class="d-flex align-center theme-back" :class="isMirrored ? 'flex-row-reverse': ''">
          <AttackDirection :gamefinished="gameFinished" :isDisabled="disableAttackDirection" ref="attackDirection"
                           :team="teamA" :direction="isMirrored ? 'right': 'left'" class="attack-direction"/>
          <TeamName :gamefinished="gameFinished" :team="teamA"
                    :teamShortName="gamedata.team_a_shortname"
                    :teamName="gamedata.team_a_name"/>
        </v-card>

        <v-card v-if="gamedata.rule !== 'STRAND'" tile flat
                class="d-flex align-center justify-center matchScore theme-back"
                :class="isMirrored ? 'flex-row-reverse': ''">
          <TeamScore :team="teamA"
                     :score="gamedata.team_a_score"
                     teamId="teamA"
                     :gamedata="gamedata"
                     :style="'text-align: '+(isMirrored?'left':'right')"/>
          <span class="pl-2 pr-2 theme-title"> - </span>
          <TeamScore :team="teamB"
                     :score="gamedata.team_b_score"
                     teamId="teamB"
                     :gamedata="gamedata"
                     :style="'text-align: '+(isMirrored?'right':'left')"/>
        </v-card>
        <v-card v-else tile flat class="d-flex align-center justify-center matchScore theme-back">
          <component :gamedata="gamedata" :is="teamScores" :appBar=false :currentPeriod="this.period"
                     :isMirrored="isMirrored"/>
        </v-card>

        <v-card tile flat class="d-flex align-center theme-back" :class="isMirrored ? 'flex-row-reverse': ''">
          <TeamName :team="teamB"
                    :teamShortName="gamedata.team_b_shortname"
                    :teamName="gamedata.team_b_name"/>
          <AttackDirection :gamefinished="gameFinished" :isDisabled="disableAttackDirection" ref="attackDirection"
                           :team="teamB" :direction="isMirrored ? 'left': 'right'" class="attack-direction"/>
        </v-card>
      </v-card>

      <v-card tile flat class="matchBox theme-back">
        <Court :gamefinished="gameFinished" parentDivID="canvas-container"
               :theme="this.$vuetify.theme.dark ? 'dark' : 'light'"
               :canvasWidth="canvasWidth" :canvasHeight="canvasHeight"
               :mirrored="isMirrored"
               :style="{width: canvasWidth, height: canvasHeight}"/>

        <v-card tile flat id="actionButtonContainer" class="theme-back">
          <v-btn-toggle id="actionButtons" :style="{width: buttonsWidth}" tile group multiple>
            <component :gamefinished="gameFinished" :hotkeys="hotkeys" :is="actionShots" :gamedata="gamedata"
                       :isComponentDisabled="parseInt(period) === 13"/>
            <component :gamefinished="gameFinished" :hotkeys="hotkeys"
                       :is="gamedata.rule === 'STRAND' ? actionTypes : actionPenaltyShots"
                       :isComponentDisabled="parseInt(period) === 13"/>
            <component :gamefinished="gameFinished" :hotkeys="hotkeys" :gamedata="gamedata"
                       :is="gamedata.rule === 'STRAND' ? actionPenaltyShots : actionLostball"
                       :isComponentDisabled="parseInt(period) === 13"/>
            <component :gamefinished="gameFinished" :hotkeys="hotkeys" :gamedata="gamedata"
                       :is="gamedata.rule === 'STRAND' ? actionLostball : actionExclusion"
                       :isComponentDisabled="parseInt(period) === 13"/>
            <component :gamefinished="gameFinished" :hotkeys="hotkeys" :gamedata="gamedata" :is="actionCards"
                       :isComponentDisabled="parseInt(period) === 13"/>
          </v-btn-toggle>
          {{ selectedAction }}
        </v-card>
      </v-card>

      <v-card tile flat class="d-flex flex-column flex-nowrap theme-back"
              :style="'height: calc(120px + 5.88%); width: calc('+canvasWidth+' + '+buttonsWidth+' + 16px);'"
              min-height="162px" width="500">
        <v-card tile flat v-if="!action" class="d-flex align-content-stretch justify flex-nowrap theme-back"
                height="120px">
          <TimelineCard v-for="(elem, index) in filteredSortedList.slice().reverse().slice(0,5)" :key="elem.UUID || elem.id || index" :index="index"
                        :item="elem" :gamedata="gamedata" :gamefinished="gameFinished" :periodItems="periodItems"/>
        </v-card>
        <a v-if="!action" @click="timeLineToggle" class="toggle-btn">
          <v-icon class="t-icon theme-text">{{ !showTimeLine ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          <span class="t-text theme-text">{{ !showTimeLine ? 'Összes esemény' : 'Bezárás' }}</span>
        </a>
        <ActionBar v-show="action && !showTimeLine" :direction="!isMirrored?teamA.isActive:teamB.isActive"
                   :gamedata="gamedata" :isMirrored="isMirrored" v-if="Object.keys(gamedata).length > 0"/>
      </v-card>

      <v-expand-transition>
        <v-card tile flat id="timelineScreen" v-show="showTimeLine"
                class="timelineScreen justify-start align-start theme-back">
          <TimelineList :items="filteredSortedList" :gamedata="gamedata" :gamefinished="gameFinished" :disabled="gameFinished"
                        :periodItems="periodItems" :period="period"/>
        </v-card>
      </v-expand-transition>
    </v-card>

    <v-card tile flat class="sideCard theme-back" :style="{width: buttonsWidth, minWidth: buttonsWidth}">
      <v-card tile flat class="personList theme-back">
        <PlayerList :gamefinished="gameFinished" :persons="{...gamedata.team_b_players}" id="teamB" team="B"
                    :isActive="teamB.isActive"
                    :show="true" :itemCount="maxTeamSize" :gamedata="gamedata" :hotkeys="hotkeys"
                    v-if="Object.keys(gamedata).length > 0 && Object.keys(gamedata.team_b_players).length > 0"
                    :actualGoalKeeper="{...gamedata.team_b_actual_goalkeeper}"
                    :playerEntry="gamedata.team_b_players_entry" :side="isMirrored ? 'left' : 'right'"/>
        <PlayerList :gamefinished="gameFinished" :persons="{...gamedata.team_b_officials}" id="staffB" team="B"
                    :isActive="teamB.isActive"
                    v-if="Object.keys(gamedata).length > 0 && Object.keys(gamedata.team_b_officials).length > 0"
                    :actualGoalKeeper="{}" :gamedata="gamedata" :hotkeys="hotkeys" :show="showB"
                    :itemCount="gamedata.team_b_officials.length" :isOver="true"/>
      </v-card>

      <a @click="showB = !showB" class="toggle-btn">
        <v-icon class="t-icon theme-text">{{ !showB ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        <span class="t-text theme-text">{{ !showB ? 'Hivatalos személyek' : 'Bezárás' }}</span>
      </a>
    </v-card>

    <v-row justify="center" class="dialog-container">
      <GoalKeeperDialog :gamedata="gamedata" :teamA="teamA" :teamB="teamB"/>

      <StrandGoalKeeperDialog :gamedata="gamedata" :teamA="teamA" :teamB="teamB" />
    </v-row>
  </v-card>
</template>

<script>
//var debug = require('debug')('MKSZ:ReportScreen');
import PlayerList from "@/components/PlayerList";
import Court from "@/components/Court";
import TimelineCard from "@/components/TimelineCard";
import TimelineList from "@/components/TimelineList";
import AttackDirection from "../components/AttackDirection";
import TeamName from "../components/TeamName";
import TeamScore from "../components/TeamScore";
import ActionBar from "../components/ActionBar";
import {hotkeys} from '@/plugins/hotkeys';
import eventBus from '@/eventBus';
import CONSTANTS from '@/constants';
import Bugsnag from "@bugsnag/js";

import store from "@/store";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import StrandGoalKeeperDialog from "@/components/dialogs/StrandGoalKeeperDialog.vue";
import GoalKeeperDialog from "@/components/dialogs/GoalKeeperDialog.vue";

export default {
  name: 'ReportScreen',
  components: {
    GoalKeeperDialog,
    StrandGoalKeeperDialog,
    TimelineCard,
    TimelineList,
    AttackDirection,
    PlayerList,
    Court,
    TeamName,
    TeamScore,
    ActionBar
  },
  props: {
    canvasWidth: String,
    canvasHeight: String,
    buttonsWidth: String,
    dark: Boolean,
    isLoggedin: Boolean,
    isMirrored: Boolean,
    hotkeys: Boolean,
    gamedata: Object,
    substituteTimeline: Array,
    period: String,
    sortedList: Array,
    periodItems: Array,
  },
  data: function () {
    return {
      action: false,
      showA: false,
      showB: false,
      selectedAction: null,
      selectedActionType: null,
      actionShots: '',
      actionPenaltyShots: '',
      actionTypes: '',
      actionExclusion: '',
      actionLostball: '',
      actionCards: '',
      teamScores: '',
      disableAttackDirection: false,
      selectedGoalkeeperA: null,
      selectedGoalkeeperB: null,
      strandSelectedGoalkeeperA: null,
      strandSelectedGoalkeeperB: null,
    }
  },
  created() {
    let self = this;

    if (!self.isLoggedin) {
      self.$router.push("/login");
      return;
    }

    this._dmrPushHandler = data => {
      // JAVÍTÁS: a `partialUpdate:true` egy ÁTMENETI jelző, ami csak azt jelzi,
      // hogy a KÜLDŐ (jellemzően a DMR) ezt a KONKRÉT kimenő üzenetet csak
      // részlegesen (jóváhagyás-mezőnkénti patch-ként) küldte, NEM a rekord
      // állandó tulajdonsága. Ha ezt itt, a FOGADÓ (CR) oldalán változatlanul
      // ráhagyjuk a helyi Vuex/IndexedDB példányra, a jelző "ráragad" a
      // rekordra - és mivel a CR saját, KÉSŐBBI, teljes tartalmi szerkesztése
      // ennek a (Vuex-ből klónozott) rekordnak a másolatából indul ki, a CR
      // saját szerkesztése is tévesen "csak jóváhagyás-mezős" csonka
      // csomagként ment ki (l. dbmanager.js sync() partialUpdate-ág), ami
      // NÉMÁN elnyeli a CR által módosított tartalmi mezőket (pl. játékos)!
      // A fogadó szemszögéből ez mindig TELJES, lezárt információ - a jelzőt
      // ezért itt törölni kell, mielőtt bármit kezdenénk vele.
      delete data.partialUpdate;

      self.$store.dispatch('game/socketDmrPush', data);

      if (data.action !== 'init' && data.params) {
        window.dbmanager.update(data, true);
      }
    };
    window.vueio.on(CONSTANTS.SOCKET.ACTIONS.DMRPUSH, this._dmrPushHandler);

    this._recordCreatedHandler = function (params) {
      if (params && params.isHistorical) return; // JAVÍTÁS: A múltbeli (DB-ből betöltött) eseményeknél nem forgatjuk a pályát!

      // JAVÍTÁS: ha ez egy MEGLÉVŐ esemény SZERKESZTÉSE (nem új rögzítés) -
      // az ActionBar.vue az afterSave()-ben ilyenkor a newRecord.modifiedRecord
      // mezőben átadja az eredeti, szerkesztett rekordot -, akkor NE fordítsuk
      // meg újra a támadási irányt. Egy visszamenőleges javítás (pl. másik
      // játékosra írjuk át a gólt) nem egy ÚJ gól/labdaszerzés, a birtoklásnak
      // emiatt nem szabadna váltania - az afterSave() már vissza is állította
      // a szerkesztés előtti irányt (resetCourtDirection()), ezt a flip-et itt
      // felülírná/érvénytelenítené.
      if (params && params.modifiedRecord && Object.keys(params.modifiedRecord).length > 0) {
        self.action = false;
        return;
      }

      self.action = false;
      if (params.action && CONSTANTS.CHANGEDIRECTION.includes(params.action)) {
        self.$nextTick(() => {
          try {
            // 1. Kiszámoljuk az új irányt (ha A aktív volt, akkor most a B iránya kell, és fordítva)
            // Ez ugyanaz a logika, amit a manuális 'changeDirection' metódus is használ.
            let newDirection = self.teamA.isActive ? self.teamB.arrowDirection : self.teamA.arrowDirection;

            // 2. Beállítjuk a rendszer állapotát (ez állítja a nyilakat a fejlécben)
            self.SET_ATTACKING_DIRECTION(newDirection);

            // 3. JAVÍTÁS: Küldünk egy eseményt a Court komponensnek is!
            // Ez csak a pályát fordítja meg (vagy állítja be), nem az egész képernyőt.
            eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIRECTION, newDirection);
          } catch (e) {
            Bugsnag.notify(e, function (ev) {
              ev.severity = 'error';
              ev.context = 'Player';
              ev.addMetadata('teamA', self.teamA);
              ev.addMetadata('teamB', self.teamB);
              ev.addMetadata('params', params);
            });
          }
        });
      }
    };
    eventBus.$on(CONSTANTS.EVENTS.RECORD.CREATED, this._recordCreatedHandler);

    this._directionChangeHandler = function (direction) {
          // --- JAVÍTÁS KEZDETE ---
          // Szigorúan ellenőrizzük, hogy STRAND kézilabdáról van-e szó!
          // A korábbi kód minden esetben lefutott, ezért nyílt meg Teremben is a dialógus.
          if (self.gamedata.rule === 'STRAND') {
            if ((self.teamA.selectedGoalkeeper && !self.teamB.selectedGoalkeeper) || (!self.teamA.selectedGoalkeeper && self.teamB.selectedGoalkeeper)) {
              self.SET_STRAND_GOALKEEPER_DIALOG(true);
              eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, true);
            }
          }
    };
    eventBus.$on(CONSTANTS.EVENTS.CHANGE.DIRECTION, this._directionChangeHandler);

    this._restoreSelectionHandler = function (record) {
      if (record && record.attackDirection) {
        self.SET_ATTACKING_DIRECTION(record.attackDirection);
        eventBus.$emit('restoreAreaSelection', record);
      }
    };
    eventBus.$on(CONSTANTS.ACTIONS.RESTORE.SELECTION, this._restoreSelectionHandler);

    this._toggleTimelineHandler = function () {
      self.timeLineToggle();
    };
    eventBus.$on(CONSTANTS.ACTIONS.TOGGLE.TIMELINE, this._toggleTimelineHandler);

    this._closeOfficialsHandler = function (team) {
      if (team === 'A') {
        self.showA = false;
      } else {
        self.showB = false;
      }
    };
    eventBus.$on(CONSTANTS.ACTIONS.CLOSE.OFFICIALSLIST, this._closeOfficialsHandler);

    this._recordCreateHandler = function (init) {
      self.action = init;
    };
    eventBus.$on(CONSTANTS.EVENTS.RECORD.CREATE, this._recordCreateHandler);

    this._selectedPlayerHandler = function (playerId) {
      self.selectPlayer(playerId);
    };
    eventBus.$on(CONSTANTS.ACTIONS.SELECTED.PLAYER, this._selectedPlayerHandler);

    this._strandGoalkeeperHandler = function () {
      if ('00:00' === window.stopwatch.getTotalTimeAsString() && self.gamedata.rule === 'STRAND') {
        if (!self.teamA.selectedGoalkeeper && !self.teamB.selectedGoalkeeper) {
          self.SET_STRAND_GOALKEEPER_DIALOG(true);
          eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, true);
        }
      }
    };
    eventBus.$on(CONSTANTS.ACTIONS.STRAND.GOALKEEPER, this._strandGoalkeeperHandler);

    this._periodChangedHandler = function (period) {
      let selectedPeriods = [];
      let periods = self.gamedata.periods;
      let lastPeriod = 0;

      self.teamA.selectedGoalkeeper = false;
      self.teamB.selectedGoalkeeper = false;
      self.disableAttackDirection = false;

      if (periods) {
        let periodIndex = periods.findIndex(x => x.value === period);

        if (periodIndex === -1 || (periodIndex && periods[periodIndex].duration === 0)) {
          self.SET_GOALKEEPER_DIALOG(false);
          self.disableAttackDirection = parseInt(self.period) !== 12; //szétlövés esetén nincs disabled
          return;
        }

        window.dbmanager.readAll().then(function (records) {
          let pastGoalkeeper = {
            A: false,
            B: false,
          }

          records.forEach(function (record) {
            if (record.action === 'gamedatachange') {
              let goalKeeperId = (record.params.value && record.params.value.id) ? record.params.value.id : 0;

              selectedPeriods.push({
                periodId: record.period,
                team: record.params.name,
                goalKeeperId: goalKeeperId,
                clientTime: record.clientTime,
                gameTime: record.params.gametime,
                totalGameTime: record.params.totalGameTime
              });
              const isStrand = self.$store.state.game.gamedata && self.$store.state.game.gamedata.rule === 'STRAND';
              const pRecord = require('@/utils/periodOrder').getChronoOrder(record.period, isStrand);
              const pLast = require('@/utils/periodOrder').getChronoOrder(lastPeriod, isStrand);
              lastPeriod = pRecord > pLast ? record.period : lastPeriod;

              if (parseInt(record.period) === parseInt(period) && goalKeeperId) {
                if (record.team === 'team_a_actual_goalkeeper') {
                  pastGoalkeeper.A = true;
                }

                if (record.team === 'team_b_actual_goalkeeper') {
                  pastGoalkeeper.B = true;
                }
              }
            }
          });

          self.teamA.selectedGoalkeeper = pastGoalkeeper.A;
          self.teamB.selectedGoalkeeper = pastGoalkeeper.B;

          selectedPeriods.sort(function (a, b) {
            if (a.totalGameTime > b.totalGameTime) {
              return 1;
            }
            return -1;
          });

          let showDialog = selectedPeriods.findIndex(x => x.periodId === period);

          if (self.gamedata.rule === 'STRAND') {
            self.SET_GOALKEEPER_DIALOG(false);
          } else {
            self.SET_GOALKEEPER_DIALOG(showDialog === -1);
          }

          let lastPeriodIndex = periods.findIndex(x => x.value === lastPeriod);

          if (showDialog === -1 && lastPeriodIndex !== -1 && selectedPeriods.length) {
            let latestGoalKeeperSetTime = 0;

            selectedPeriods.forEach(function (period) {
              if (period.periodId === lastPeriod && period.totalGameTime >= latestGoalKeeperSetTime) {
                latestGoalKeeperSetTime = period.totalGameTime;
                switch (period.team) {
                  case 'team_a_actual_goalkeeper':
                    self.teamA.goalkeeper = {value: period.goalKeeperId ? period.goalKeeperId : 0};
                    break;
                  case 'team_b_actual_goalkeeper':
                    self.teamB.goalkeeper = {value: period.goalKeeperId ? period.goalKeeperId : 0};
                    break;
                }
              }
            });
          }
        });
      }
    };
    eventBus.$on(CONSTANTS.EVENTS.PERIOD.CHANGED.SELECTEDPERIOD, this._periodChangedHandler);
  },
  beforeDestroy() {
    // Socket listener cleanup
    if (this._dmrPushHandler) {
      window.vueio.off(CONSTANTS.SOCKET.ACTIONS.DMRPUSH, this._dmrPushHandler);
    }

    // EventBus listener cleanup
    if (this._recordCreatedHandler) eventBus.$off(CONSTANTS.EVENTS.RECORD.CREATED, this._recordCreatedHandler);
    if (this._directionChangeHandler) eventBus.$off(CONSTANTS.EVENTS.CHANGE.DIRECTION, this._directionChangeHandler);
    if (this._restoreSelectionHandler) eventBus.$off(CONSTANTS.ACTIONS.RESTORE.SELECTION, this._restoreSelectionHandler);
    if (this._toggleTimelineHandler) eventBus.$off(CONSTANTS.ACTIONS.TOGGLE.TIMELINE, this._toggleTimelineHandler);
    if (this._closeOfficialsHandler) eventBus.$off(CONSTANTS.ACTIONS.CLOSE.OFFICIALSLIST, this._closeOfficialsHandler);
    if (this._recordCreateHandler) eventBus.$off(CONSTANTS.EVENTS.RECORD.CREATE, this._recordCreateHandler);
    if (this._selectedPlayerHandler) eventBus.$off(CONSTANTS.ACTIONS.SELECTED.PLAYER, this._selectedPlayerHandler);
    if (this._strandGoalkeeperHandler) eventBus.$off(CONSTANTS.ACTIONS.STRAND.GOALKEEPER, this._strandGoalkeeperHandler);
    if (this._periodChangedHandler) eventBus.$off(CONSTANTS.EVENTS.PERIOD.CHANGED.SELECTEDPERIOD, this._periodChangedHandler);
    if (this._cardsCreatedHandler) eventBus.$off(CONSTANTS.EVENTS.COMPONENTS.ACTION.CARDS.CREATED, this._cardsCreatedHandler);
  },
  mounted() {
    let self = this;

    if (window.stopwatch.getTotalTime() === 0
        && (!self.gamedata.team_a_actual_goalkeeper || !self.gamedata.team_a_actual_goalkeeper.id)
        && (!self.gamedata.team_b_actual_goalkeeper || !self.gamedata.team_b_actual_goalkeeper.id)
    ) {
      let numOfGoalKeepers = 0;
      let playersA = self.gamedata.team_a_players || [];
      let playersB = self.gamedata.team_b_players || [];

      [
        ...playersA,
        ...playersB,
      ].forEach(function (player) {
        if (player.goalkeeper) {
          numOfGoalKeepers++;
        }
      });

      if (numOfGoalKeepers === 0) {
        if (self.gamedata.team_a_actual_goalkeeper && self.gamedata.team_a_actual_goalkeeper.id !== null &&
            self.gamedata.team_b_actual_goalkeeper && self.gamedata.team_b_actual_goalkeeper.id !== null
        ) {
          eventBus.$emit(CONSTANTS.EVENTS.CHANGE.GAMEDATA, ('team_a_actual_goalkeeper'), {id: null});
          eventBus.$emit(CONSTANTS.EVENTS.CHANGE.GAMEDATA, ('team_b_actual_goalkeeper'), {id: null});

          eventBus.$emit(CONSTANTS.EVENTS.CHANGE.GOALKEEPERS, {
            teamA: null,
            teamB: null,
          });
        }
      } else {
        if (self.gamedata.rule === 'STRAND') {
          eventBus.$emit(CONSTANTS.EVENTS.CHANGE.GAMEDATA, ('team_a_actual_goalkeeper'), {id: null});
          eventBus.$emit(CONSTANTS.EVENTS.CHANGE.GAMEDATA, ('team_b_actual_goalkeeper'), {id: null});

          eventBus.$emit(CONSTANTS.EVENTS.CHANGE.GOALKEEPERS, {
            teamA: null,
            teamB: null,
          });
        } else {
          self.SET_GOALKEEPER_DIALOG(true);
          eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, true);
        }
      }
    }
    eventBus.$emit(CONSTANTS.EVENTS.CLOCK.CHECK);
  },
  watch: {
    'gamedata.rule': {
      handler(newRule) {
        if (newRule) {
          console.log("Szabály megérkezett/változott:", newRule);

          // Itt újra meghívjuk a betöltést azokra a komponensekre, amik függnek a szabálytól
          // A második paraméter (true) egy "force" flag lehet, ha a kódod támogatja,
          // vagy egyszerűen csak hívd meg újra.
          this.loadComponents([
            'ActionShots',
            'ActionPenaltyShots',
            newRule === 'STRAND' ? 'ActionTypes' : 'ActionExclusion',
            'ActionLostball',
            'ActionCards',
            newRule === 'STRAND' ? 'TeamScores' : null
          ], false, this, () => {
            // Előző listener eltávolítása a duplikáció megelőzéséért
            if (this._cardsCreatedHandler) {
              eventBus.$off(CONSTANTS.EVENTS.COMPONENTS.ACTION.CARDS.CREATED, this._cardsCreatedHandler);
            }
            this._cardsCreatedHandler = () => {
              eventBus.$emit('LOADQUEUE');
            };
            eventBus.$on(CONSTANTS.EVENTS.COMPONENTS.ACTION.CARDS.CREATED, this._cardsCreatedHandler);
          });
        }
      },
      immediate: true // Ez fontos, ha esetleg már betöltéskor rendelkezésre állna az adat
    }
  },
  methods: {
    ...mapActions('game', ['selectPlayer']),
    ...mapMutations('ui', ['SET_SHOWTIMELINE', 'SET_GOALKEEPER_DIALOG',
      'SET_STRAND_GOALKEEPER_DIALOG']),
    ...mapMutations('game', ['SET_ATTACKING_DIRECTION']),

    changeDirection: function () {
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIRECTION, this.teamA.isActive ? this.teamB.component.direction : this.teamA.component.direction);
    },
    timeLineToggle: function () {
      this.SET_SHOWTIMELINE(!this.showTimeLine);

      document.getElementById("timelineScreen").scrollTop = 0;
    },
    async loadComponents(components, defaultRoute = false, parentComponent = this, callback = () => {
    }) {
      let self = parentComponent;
      if (!self.gamedata || typeof self.gamedata.rule === 'undefined') {
        console.log("Várakozás a gamedata.rule-ra...");
        return;
      }
      let prefix = defaultRoute ? '' : self.gamedata.rule === 'STRAND' ? 'strand' : 'terem';

      for (const componentName of components) {
        if (componentName && typeof componentName !== 'undefined') {
          let componentDataName = componentName.charAt(0).toLowerCase() + componentName.slice(1);
          let path = prefix + '/' + componentName;

          try {
            const module = await import(`../components/${path}`);
            if (typeof self[componentDataName] !== 'undefined' && typeof module !== 'undefined') {
              Object.assign(self.$options.components, {
                [componentName]: module.default
              });
              self[componentDataName] = module.default.name;
            }
          } catch (e) {
            console.error("A következő komponens betöltése sikertelen: " + componentName);
          }
        }
      }
      callback();
    },
  },
  computed: {
    ...mapState('ui', ['goalkeeperDialog', 'strandGoalkeeperDialog', 'showTimeLine']),
    ...mapState('game', ['teamA', 'teamB', 'actualGoalkeepers', 'gameFinished']),
    ...mapGetters('game', ['getTeamGoalkeepers', 'maxTeamSize']),

    // JAVÍTÁS: A CONSTANTS.TIMELINEACTIONS.REPORT fehérlista használata
    filteredSortedList() {
      if (!this.sortedList) return [];

      return this.sortedList.filter(item => {
        // Csak azokat engedjük át, amelyek szerepelnek a konstans listában
        return CONSTANTS.TIMELINEACTIONS.REPORT.includes(item.action);
      });
    },

    keymap: function () {
      let self = this;
      return {
        [hotkeys['directionChange']]: self.hotkeys ? this.changeDirection : '',
      }
    },
  },
}
</script>

<style scoped>
.mainContent {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: row;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
}

.mainContentReversed {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: row;
  flex-direction: row-reverse;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
}

.midContent {
  height: 100%;
  display: flex;
  flex-flow: column;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  position: relative;
  flex-shrink: 1;
  overflow: hidden;
}

.sideCard {
  height: 100%;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  display: flex;
  flex-flow: column;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  position: relative;
}

.topButtonset {
  padding-left: 16px;
  padding-right: 16px;
}

.personList {
  position: relative;
  width: 100%;
  flex: 1 1 94.12%;
}

.toggle-btn {
  flex: 0 1 5.88%;
  min-height: 42px;
  width: 100%;
  display: flex;
  flex-flow: row;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  text-decoration: none;
  text-align: center;
  padding: 0 10px;
}

.toggle-btn > .t-text {
  font-size: 12px;
  font-weight: normal;
  font-stretch: condensed;
  font-family: 'Roboto Condensed';
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}

.toggle-btn > .t-icon {
  font-size: 20px;
}

#timelineScreen {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  background-color: white;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  overflow-y: scroll;
  transition: all 280ms;
  transition-property: unset;
}

.matchBox {
  width: 100%;
  height: calc(94.12% - 187px);
  display: flex;
  flex-flow: row;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  padding-left: 16px;
}

#actionButtonContainer {
  height: 100%;
}

#actionButtons {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  height: 100%;
  display: block;
}

.matchScore {
  font-size: 30px;
  font-weight: 900;
  letter-spacing: -1px;
  text-align: center;
  color: #000000;
}

button.changeDirection {
  display: flex;
  flex-flow: row;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  border-width: 1px;
  border-style: solid;
  height: 43px;
  min-height: 43px;
  min-width: 70px;
  width: 70px;
  padding: 0 !important;
  margin-left: 15px;
  margin-right: 15px;
}

.arrow-icon {
  display: block;
}

.theme--light.changeDirection {
  pointer-events: all;
  background-color: #000000 !important;
  border-color: #000000 !important;
}

.theme--dark.changeDirection {
  pointer-events: all;
  background-color: #ffffff !important;
  border-color: #ffffff !important;
}

.theme--light.changeDirection svg {
  fill: #ffffff;
}

.theme--dark.changeDirection svg {
  fill: #1e2028;
}
</style>
